export const replaceQueryParams = (params: Record<string, string | number | undefined>) => {
  const url = new URL(window.location.href);
  const hashParts = url.hash.split("?");
  const searchParams = new URLSearchParams(hashParts[1] || "");

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === "" || value === 1) {
      // NOTE: 数値はページ番号を念頭に置いているため1の場合は不要にしている
      searchParams.delete(key);
    } else {
      searchParams.set(key, String(value));
    }
  });

  const queryString = searchParams.toString();
  const newHash = `${hashParts[0]}${queryString ? "?" + queryString : ""}`;

  if (url.hash !== newHash) {
    history.replaceState(undefined, undefined, newHash);
  }
};

export const getQueryParam = (key: string): string | undefined => {
  const url = new URL(window.location.href);
  const hashParts = url.hash.split("?");
  if (hashParts.length < 2) return undefined;

  const searchParams = new URLSearchParams(hashParts[1]);
  return searchParams.get(key);
};
